import React from "react";
import _ from "lodash";

const JobSummary = (props) => (
  <section className="dt-card mb-3">
    <div className="dt-card__head">
      <h2 className="dt-card__title">Jobs Overview</h2>
    </div>
    <div className="streaks-grid">
      <div
        className="dt-streak clickable"
        title="View all Delayed Backlogs (Till date)"
        onClick={() => props.onFilter(1)}
      >
        <div className="dt-streak__ico" style={{ background: "var(--coral-wash)", color: "var(--coral)" }}>
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>
        </div>
        <div className="dt-streak__n" style={{ color: "var(--coral)" }}>
          {_.get(props, "stats.backlog", "0")}
        </div>
        <div className="dt-streak__l">Delayed (Till date backlog)</div>
      </div>

      <div
        className="dt-streak clickable"
        title="View all Upcoming (Today)"
        onClick={() => props.onFilter(2)}
      >
        <div className="dt-streak__ico" style={{ background: "var(--amber-wash)", color: "var(--amber)" }}>
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
        </div>
        <div className="dt-streak__n" style={{ color: "var(--amber)" }}>
          {_.get(props, "stats.upcoming", "0")}
        </div>
        <div className="dt-streak__l">Upcoming (Due today)</div>
      </div>

      <div
        className="dt-streak clickable"
        title="View all Complete (This Week)"
        onClick={() => props.onFilter(3)}
      >
        <div className="dt-streak__ico" style={{ background: "var(--mint-wash)", color: "var(--mint)" }}>
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12.5 4.5 4.5L19 7"/></svg>
        </div>
        <div className="dt-streak__n" style={{ color: "var(--mint)" }}>
          {_.get(props, "stats.completed", "0")}
        </div>
        <div className="dt-streak__l">Complete (This Week)</div>
      </div>
    </div>
  </section>
);

export default JobSummary;
